/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const baseColumnsTelemetri = [
  { Header: "Cihaz ID", accessor: "cihaz_id" },
  { Header: "Firma", accessor: "firma" },
  { Header: "İş Ortağı", accessor: "is_ortagi" },
  { Header: "IMEI", accessor: "imei" },
  { Header: "Plaka", accessor: "plaka" },
  { Header: "SIM No", accessor: "sim_no" },
  { Header: "Km", accessor: "odometer", sortable: true }, 
  { Header: "Aktiflik", accessor: "aktiflik" }, 
  { Header: "Kontak", accessor: "ignition" }, 
  { Header: "Son Aktiflik", accessor: "son_aktiflik", sortable: true }, // ✅ backend'den gelen
  { Header: "Son Konum Zamanı", accessor: "son_konum_zamani", sortable: true },
  { Header: "Hız", accessor: "hiz", sortable: true }, // ✅ hız eklendi

  { Header: "Adres", accessor: "adres" },         // ✅ yeni alan
  { Header: "Cihaz Tipi", accessor: "cihaz_tipi" },
  { Header: "Protokol", accessor: "protocol" },   // ✅ veri_tipi → protocol
  { Header: "UETDS", accessor: "uetds" },
  { Header: "Son UETDS zamanı", accessor: "uetds_son_gonderim_zamani" },
];

// Role göre kolonları filtrele - bayi rolünde "İş Ortağı" kolonunu gizle
export const getColumnsTelemetri = (userRole) => {
  if (userRole === "bayi") {
    return baseColumnsTelemetri.filter(col => col.accessor !== "is_ortagi");
  }
  return baseColumnsTelemetri;
};

// Backward compatibility için default export
export const columnsTelemetri = baseColumnsTelemetri;

export default columnsTelemetri;
